enum Color {
    Black = "#333333",
    White = "#FFFFFF",
    Coral = "#FFA184",
    Gold = "#DAB070",
}

export default Color